// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2PaymentTypeModel {
    static getAttributeTypeMap() {
        return EnrollmentV2PaymentTypeModel.attributeTypeMap;
    }
}
EnrollmentV2PaymentTypeModel.discriminator = undefined;
EnrollmentV2PaymentTypeModel.additionalProperties = false;
EnrollmentV2PaymentTypeModel.attributeTypeMap = [
    {
        "name": "paymentTypeId",
        "baseName": "paymentTypeId",
        "type": "number"
    },
    {
        "name": "paymentTypeCode",
        "baseName": "paymentTypeCode",
        "type": "string"
    },
    {
        "name": "paymentTypeDescription",
        "baseName": "paymentTypeDescription",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2PaymentTypeModel.js.map